import React from 'react';
import { ReportDeviation } from './ReportDeviation';
import { fetchPostCourierDeviationAsync } from 'fetch/deviationFetch';
import { Order } from '../../types/orderTypes';

export function ReportCourierDeviationPost({
  order,
}: {
  order: Order;
}): JSX.Element {
  const sendMessage = async (_, message, status) => {
    await fetchPostCourierDeviationAsync(order.id, message, status);
    setTimeout(() => window.location.reload(), 1600);
  };

  return (
    <>
      <ReportDeviation
        order={order}
        sendMessage={sendMessage}
        showCourierDeviationWarning={true}
      />
    </>
  );
}
